<template>
  <a
    :href="'/' + $i18n.locale + '/article/' + article[$i18n.locale]?.rel_link"
  >
    <article
      class="article-preview-item"
    >
      <div class="article-preview-item-thumbnail">
        <img :src="getWebp(article[$i18n.locale]?.thumbnail?.url)" :alt="article[$i18n.locale]?.title"/>
      </div>
      <div class="article-preview-item-title">
        {{ article[$i18n.locale]?.title }}
      </div>
      <div class="article-preview-item-date">
        {{ showDate(article?.createdAt) }}
      </div>
      <div class="article-preview-item-description">
        {{ article[$i18n.locale]?.description?.length > 64 ? article[$i18n.locale]?.description.substr(0, 64) + "\u2026" : article[$i18n.locale]?.description }}
      </div>
    </article>
  </a>
</template>

<script>

export default {
  name: 'article-preview',

  props: {
    article: {
      type: Object,
    },
  },

  data () {
    return { };
  },

  methods: {
    getWebp(url) {
      try {
        return url.substr(0, url.lastIndexOf('.')) + '.webp';
      } catch (error) {
        return url;
      }
    },

    showDate (date_string) {
      let date = new Date(date_string);

      let locale = this.$i18n.locale == 'en' ? 'en-US' : 'de-DE';

      let date_name = date.toLocaleDateString(locale, {
          weekday: 'long',
        });

      let month_name = date.toLocaleDateString(locale, {
          month: 'long',
        });

      let _date = `${('0' + date.getDate()).slice(-2)} ${month_name} ${date.getFullYear()}`

      date_name += ` ${_date}`;

      return date_name.toUpperCase();
    },
  },

  mounted () {

  },
}
</script>

<style lang="scss">
  .article-preview {
    &-item {
      width: 330px;
      color: #242424 !important;
      margin: 20px;

      @media(max-width: 600px) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
      }

      cursor: pointer;

      &:hover {
        .article-preview-item-thumbnail:after {
          opacity: .35;
        }

        .article-preview-item-title {
          color: var(--va-primary)
        }
      }

      &-thumbnail {
        position: relative;

        width: 100%;
        height: 220px;

        @media(max-width: 600px) {
          height: 300px;
        }

        &:after {
          content: "";
          bottom: 0;
          left: 0;
          position: absolute;
          border-radius: 3px;
          width: 100%;
          height: 100%;
          opacity: .0;
          background: linear-gradient(180deg,transparent,transparent 18%,#000);
          transition: all .3s ease;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;

          border: 1px solid #eee
        }
      }

      &-title {
        font-family: 'Lato-Bold';
        font-size: 18px;
        line-height: 28px;
        margin-top: 12px;
      }

      &-date {
        font-size: 14px;
        line-height: 18px;
        margin-top: 8px;

        color: var(--va-primary)
      }

      &-description {
        font-size: 16px;
        line-height: 18px;
        margin-top: 8px;
      }
    }
  }
</style>
